export default [10042, 10046];
